import React from "react";
import { Col, Typography } from "antd";
import { dateFormat } from "../../../commonFuntions/CommonUtilFunctions";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-right.svg";
import "../contentcard.css";

export const RFQOrder = (props) => {
  const { data } = props;
  const { Text } = Typography;
  return (
    <>
      <Col className="rejected-card-container">
        {data?.map((val, idx) => (
          <Col key={idx} className="rejected-card-data-container">
            <Col className="rejected-card-data-sub-container">
              <Col className="rejected-card-data-sub-id-container">
                <Text className="rejected-card-data-sub-id-text">
                  {val?.rfq_id}
                </Text>
                <Text className="rejected-card-data-sub-name-text">
                  {dateFormat(val?.created_at)}
                </Text>
              </Col>
              <Col className="rfq-requests-card-content-container">
                <Col className="rfq-order-card-content-sub-container">
                  <Text className="rejected-card-amount-sub-text">
                    {val?.rfq_created_by?.full_name || "N/A"}
                  </Text>
                  <Text className="rejected-card-amount-sub-text-item">
                    {val?.rfq_created_by?.phone_number || "N/A"}
                  </Text>
                </Col>
                <Col className="rejected-card-status-container">
                  <Col className="rfq-order-status-container">
                    {val?.rfq_status}
                  </Col>
                  <Link
                    to={`/admin/rfq/quotes/${val?.rfq_id}`}
                    target="_blank"
                    // onClick={() => handleNavigateToRFQDetails(params)}
                  >
                    <ArrowIcon />
                  </Link>
                </Col>
              </Col>
            </Col>
          </Col>
        ))}
      </Col>
    </>
  );
};
